import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { blockOrUnblockUser } from "../../store/slices/adminSlice";
import SettingsLayout from "../../layouts/SettingsLayout";
import {
  Button,
  Input,
  useDisclosure,
  Modal,
  ModalContent,
  ModalBody,
  Checkbox,
} from "@nextui-org/react";
import { inputStyle, inputWrapperStyle } from "../../data/inputStyleData";
import { useNavigate } from "react-router-dom";
import Resizer from "react-image-file-resizer";
import axios from "axios";
import { toast } from "react-toastify";
import { User } from "@nextui-org/react";
import { getCommissionRate } from "../../store/slices/adminSlice";
import { deleteUserAPI } from "../../store/slices/adminSlice";
import DeleteModal from "./DeleteModal";
import CommissionModel from "./CommissionModel";
import ContactModal from "./ContactModal";
import { FaUser } from "react-icons/fa6";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const UpdateProfile = () => {
  const [userdata, setUserdata] = useState([]);
  const [img, setImg] = useState();
  const { id } = useParams();
  const [role, setRole] = useState("");
  const [userBlock, setUserBlock] = useState("Block");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [rate, setRate] = useState("");
  const [value, setValue] = useState(false);
  const [commission, setCommission] = useState(0);
  const [block, setBlock] = useState();
  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();

  const {
    isOpen: addModal,
    onOpen: sumModal,
    onClose: closeModal,
  } = useDisclosure();

  const {
    isOpen: confirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return localStorage.getItem("accessToken");
  };
  const jsonHeaders = (token) => ({
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const multipartHeaders = (token) => ({
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      last_name: "",
      phone: "",
      password: "",
      email: "",
      address_line_1: "",
      address_line_2: "",
      country: "",
      state: "",
      city: "",
      postcode: "",
      company_name: "",
      business_name: "",
      Industry: "",
      capricorn_number: "",
    },
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetails = async () => {
    try {
      const token = await ensureAuth();
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/getuser?userId=${id}`,
        jsonHeaders(token)
      );
      setUserdata(res.data);
      setRole(res.data.details.role);
      const status = res.data.details.status;
      setBlock(status === "BLOCKED_BY_ADMIN" || status === "BLOCKED_BY_USER");
    } catch (error) {
      // console.log(error);
    }
  };
  const handleDelete = () => {
    if (userdata.details?.id) {
      dispatch(refreshIfNeeded()).finally(() => {
        dispatch(deleteUserAPI(userdata.details.id));
      });
      navigate("/users");
      onConfirmClose();
    }
  };
  const handleActivateToggle = async () => {
    try {
      const currentPermission = userdata.details.permission;
      const newAction = currentPermission === "ACTIVE" ? "INACTIVE" : "ACTIVE";

      const token = await ensureAuth();
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/admin/active-users/${id}?action=${newAction}`,
        {},
        jsonHeaders(token)
      );

      toast.success(
        `User ${
          newAction === "ACTIVE" ? "activated" : "deactivated"
        } successfully ⭐`
      );
      userDetails(); // Refresh after update
    } catch (error) {
      toast.error("Failed to update user status ❌");
    }
  };

  const blockSupplier = () => {
    const isBlocked =
      userdata.details.status === "BLOCKED_BY_ADMIN" ||
      userdata.details.status === "BLOCKED_BY_USER";

    dispatch(refreshIfNeeded())
      .then(() => dispatch(blockOrUnblockUser(id, userdata.details.status)))
      .then(() => {
        toast.success(
          isBlocked
            ? "User unblocked successfully ⭐"
            : "User blocked successfully ⭐"
        );
        userDetails(); // refresh
      })
      .catch(() => toast.error("Block/unblock failed"));
  };
  const handleUpload = async (e) => {
    let img = e.target.files;
    try {
      Resizer.imageFileResizer(
        img[0],
        300,
        300,
        "JPEG",
        100,
        0,
        async (uri) => {
          let formData = new FormData();
          formData.append("file", uri);
          const token = await ensureAuth();
          await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/admin/profile/upload/${id}`,
            formData,
            multipartHeaders(token)
          );
          toast.success("Updated successfully ⭐");
          window.location.reload();
        },
        "file",
        200,
        200
      );
    } catch (err) {
      // console.log(err);
    }
  };

  // const handleCommission = (e) => {
  //   setRate(Number(e.target.value));
  //   console.log("Commission rate updated to:", value);
  // };

  const handleCommission = (e) => {
    const value = e.target.value;
    if (value === "") {
      setRate("");
    } else {
      setRate(Number(value));
    }
    console.log("Commission rate updated to:", value);
  };

  const getCommission = async () => {
    try {
      const token = await ensureAuth();
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/commssionrate/${id}`,
        jsonHeaders(token)
      );
      setValue(true);
      setRate(res.data?.details?.commissionRate?.rate);
    } catch (error) {
      // console.log(error);
      setValue(false);
    }
  };
  useEffect(() => {
    if (id) {
      getCommission();
    }
  }, [id]);
  const addModel = () => {
    sumAssignee();
  };

  const addCommissionModal = () => {
    sumModal();
  };
  // console.log(rate);

  const addCommission = async () => {
    let data = {
      rate: rate,
    };
    // console.log("Requesssssst Data:", data);

    try {
      const token = await ensureAuth();
      let res;
      if (value) {
        res = await axios.put(
          `${process.env.REACT_APP_SERVER_URL}/admin/updatecommssionrate/${id}`,
          data,
          jsonHeaders(token)
        );
        setRate(res.data.details.commissionRate?.rate);
        setCommission(res.data.details.commissionRate?.rate);
        toast.success("Updated successfully ⭐");
        // console.log("SetRATE", setRate)
        // console.log("SetCommission", setCommission)
        closeAssignee();
      } else {
        res = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/admin/addcommssionrate/${id}`,
          data,
          jsonHeaders(token)
        );
        setCommission(res.data.details.commissionRate?.rate);
        toast.success("Created successfully ⭐");
        closeAssignee();
      }
      dispatch(getCommissionRate());
    } catch (error) {
      const err = error.response.data.message;
      toast.error(err);
    }
  };

  // console.log(value);
  const updateUser = async (data) => {
    delete data.email;
    delete data.city;
    delete data.profile_id;

    //     if (role === "SUPPLIER") {
    //   delete data.business_name;
    //   delete data.Industry; // <-- Don't send Industry if SUPPLIER
    // } else {
    //   delete data.company_name;
    // }

    try {
      const token = await ensureAuth();
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/admin/updateuserdetail/${id}`,
        data,
        jsonHeaders(token)
      );
      toast.success("Updated successfully ⭐");
      navigate("/administration");
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        await dispatch(refreshIfNeeded());
        await userDetails();
      })();
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (userdata.details) {
      reset({
        first_name: userdata.details.first_name,
        last_name: userdata.details.last_name,
        phone: userdata.details.phone,
        email: userdata.details.email,

        address_line_1: userdata.details.address_line_1,
        address_line_2: userdata.details.address_line_2,
        country: userdata.details.country,
        state: userdata.details.state,
        city: userdata.details.suburb,
        postcode: userdata.details.postcode,
        profile_id: userdata.details.profile_id,
        business_name: userdata.details.business_name,
        Industry: userdata.details.Industry,
        capricorn_number: userdata.details.capricorn_number,
        company_name: userdata.details.company_name,
      });
    }
  }, [userdata, reset]);

  return (
    <div className="px-2 sm:px-8 md:px-14 select-none">
      <div className="py-4 flex flex-col md:flex-row gap-4 md:gap-0 md:justify-between md:items-center">
        <div className="py-3 flex flex-col sm:flex-row items-center gap-4">
          {console.log("USERDATA", userdata)}
          {userdata.details?.profile_id ? (
            <img
              src={userdata.details.profile_id}
              alt="profile-pic"
              height="120px"
              width="120px"
              className="rounded-full"
            />
          ) : (
            <User
              as="button"
              avatarProps={{
                isBordered: false,
                src: img,
                showFallback: true,
                fallback: <FaUser fontSize={18} color="gray" />,
              }}
            />
          )}

          <div className="text-center sm:text-left">
            <p className="text-base font-semibold capitalize">
              <span>{userdata.details?.email}</span>
            </p>
            <p className="text-xs">{userdata?.details?.role}</p>

            <button
              className="bg-red-600 text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 py-1 px-4 rounded-md mt-2"
              onClick={onConfirmOpen}
            >
              Delete
            </button>
          </div>
        </div>

        <div>
          <Input
            type="file"
            label="Edit Your Profile Image"
            className="mb-2"
            classNames={{
              input: [...inputStyle, "user-profile"],
              inputWrapper: inputWrapperStyle,
            }}
            accept="image/*"
            labelPlacement={"outside"}
            placeholder="Choose images"
            description={"( File Should Not Be Greater Than 5MB )"}
            onChange={(e) => handleUpload(e)}
          />
        </div>
      </div>
      <form className="md:px-10 space-y-12" onSubmit={handleSubmit(updateUser)}>
        <SettingsLayout heading="Personal Info">
          <div className="grid sm:grid-cols-2 gap-6 mb-4">
            <Controller
              control={control}
              name="first_name"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field} // value & onChange yaha bind ho jata hai
                  type="text"
                  label="First Name"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                />
              )}
            />
            <Controller
              control={control}
              name="last_name"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="Last Name"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />
            <Controller
              control={control}
              name="phone"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="number"
                  label="Phone Number"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  onWheel={(e) => e.target.blur()}
                />
              )}
            />
            <Controller
              control={control}
              name="password"
              render={({ field }) => (
                <Input
                  {...field}
                  type="password"
                  label="Password"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />

            <Controller
              control={control}
              name="email"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="email"
                  label="Email"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />
          </div>
        </SettingsLayout>
        <SettingsLayout heading="Address Info">
          <div className="grid sm:grid-cols-2 gap-6 ">
            <Controller
              control={control}
              name="address_line_1"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="Address Line 1"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />
            <Controller
              control={control}
              name="address_line_2"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="Address Line 2"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />

            <Controller
              control={control}
              name="country"
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="Country"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  isReadOnly
                  className="pointer-events-none"
                />
              )}
            />
            <Controller
              control={control}
              name="state"
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="State"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  isReadOnly
                  className="pointer-events-none"
                />
              )}
            />
            <Controller
              control={control}
              name="city"
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="City"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />
            <Controller
              control={control}
              name="postcode"
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="Post Code"
                  labelPlacement="outside"
                  classNames={{ input: ["capitalize"] }}
                  variant="bordered"
                  placeholder=" "
                />
              )}
            />
          </div>
        </SettingsLayout>
        <SettingsLayout heading="Business Info">
          <div className="grid sm:grid-cols-2 gap-6 ">
            {role === "SUPPLIER" ? (
              <Controller
                control={control}
                name="company_name"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="text"
                    label="Company Name"
                    labelPlacement="outside"
                    variant="bordered"
                    placeholder=" "
                    isReadOnly
                  />
                )}
              />
            ) : (
              <Controller
                control={control}
                name="business_name"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="text"
                    label="Business Name"
                    labelPlacement="outside"
                    variant="bordered"
                    placeholder="Not Provided"
                    isReadOnly
                  />
                )}
              />
            )}
            {role === "CUSTOMER" && (
              <Controller
                control={control}
                name="Industry"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="text"
                    label="Industry Type"
                    labelPlacement="outside"
                    variant="bordered"
                    placeholder="Not Provided"
                    isReadOnly
                  />
                )}
              />
            )}
            <Controller
              control={control}
              name="capricorn_number"
              render={({ field }) => (
                <Input
                  {...field}
                  type="number"
                  label="Capricorn Number"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder="Not Provided"
                  isReadOnly
                />
              )}
            />
            <Button
              onPress={addCommissionModal}
              className="border bg-white text-blue-500 border-lightBlue mt-6  font-semibold mb-5  mobile-only:w-full"
            >
              Contract Info
            </Button>

            {role === "SUPPLIER" && (
              <Button
                onPress={addModel}
                className="bg-lightBlue mt-6 text-white font-semibold mb-5 px-7 mobile-only:w-full"
              >
                Check Commission Rate
              </Button>
            )}
          </div>
        </SettingsLayout>
        <SettingsLayout>
          <div>
            <Button
              className="bg-lightBlue text-white font-semibold mb-5 px-7 mobile-only:w-full"
              type="submit"
            >
              Update
            </Button>
            <Button
              className="bg-purpleBtn text-white font-semibold px-7 sm:ml-7 mobile-only:w-full"
              onClick={blockSupplier}
            >
              {block ? "Unblock" : "Block"}
            </Button>
            {userdata.details?.permission && (
              <Button
                className="bg-lightBlue text-white font-semibold mb-5 px-7 mobile-only:w-full ml-5 border-2"
                type="button"
                onClick={handleActivateToggle}
              >
                {userdata.details.permission === "ACTIVE"
                  ? "Deactivate"
                  : "Activate"}
              </Button>
            )}
          </div>
        </SettingsLayout>
      </form>

      {confirmOpen && (
        <DeleteModal
          isOpen={confirmOpen}
          onClose={onConfirmClose}
          onConfirm={handleDelete}
        />
      )}

      <CommissionModel
        isOpen={addAssignee}
        onClose={closeAssignee}
        rate={rate}
        handleCommission={handleCommission}
        addCommission={addCommission}
      />
      <ContactModal
        isOpen={addModal}
        onClose={closeModal}
        userdata={userdata}
      />
    </div>
  );
};

export default UpdateProfile;
